/**
 * E-posta adresleri ASCII olmalidir. Turkce klavyede "i" yerine
 * noktasiz "ı" (veya İ/ğ/ü/ş/ö/ç) yazilinca tarayici tip=email
 * dogrulamasi kafa karistirici hata verir.
 */
const TR_TO_ASCII: Record<string, string> = {
  ı: "i",
  İ: "i",
  I: "i",
  ğ: "g",
  Ğ: "g",
  ü: "u",
  Ü: "u",
  ş: "s",
  Ş: "s",
  ö: "o",
  Ö: "o",
  ç: "c",
  Ç: "c",
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmailInput(raw: string): string {
  let out = "";
  for (const ch of raw.trim()) {
    out += TR_TO_ASCII[ch] ?? ch;
  }
  return out.toLowerCase();
}

export function isValidEmail(raw: string): boolean {
  const email = normalizeEmailInput(raw);
  return EMAIL_RE.test(email);
}

export function validateEmailInput(raw: string): string | null {
  const email = normalizeEmailInput(raw);
  if (!email) return "E-posta zorunludur.";
  if (!EMAIL_RE.test(email)) {
    return "Gecerli bir e-posta yazin (ornek: ali.veli@ornek.com). Turkce karakter kullanmayin.";
  }
  return null;
}
